import * as I18n from 'circe/I18n';
import { isArray } from 'util';

export const formatRequest = (payload) => ({
  driverInfo: {
    base: {
      latitude: 0,
      longitude: 0,
    },
    license: 'string',
    maxDistance: 0,
    tags: ['string'],
  },
  vehicleInfo: {
    baseLocation: {
      latitude: 0,
      longitude: 0,
    },
    maxDistance: 0,
    params: {
      address: 'string',
      axles: 0,
      capacity: {
        height: 0,
        length: 0,
        width: 0,
      },
      licensePlate: 'string',
      maxTrailers: 0,
      maxWeight: 0,
      name: 'string',
      owner: 'string',
      size: {
        height: 0,
        length: 0,
        width: 0,
      },
      startingWeight: 0,
      tareWeight: 0,
      tempRange: {
        excludeMax: true,
        excludeMin: true,
        maximum: 0,
        minimum: 0,
      },
      type: 'VAN',
      vin: 'string',
    },
    vehicleId: 'string',
  },
});

export const isLicensePlate = (val) => (val.length === 10
  ? undefined
  : I18n.str('invalidLicensePlate', 'Please enter a valid license plate ex: 0000 A A A'));

export const isValidPassword = (val) => (val.length >= 6
  ? undefined
  : I18n.str('invalidPassword', 'Password is short must be more than 6 characters'));

export const isValidAddress = (val) => (isArray(val) && val[0].geometry
  ? undefined
  : I18n.str('invalidAddress', 'Please select an address'));
